import { FC, useState } from 'react';
import AppSafeLink from 'components/AppSafeLink/AppSafeLink';
import Modal, { Header } from 'components/Modal';
import IconClose from 'components/Icons/IconClose';
import { GetReadyToVoteItem } from './utils/getReadyToVoteBoxes';

interface GetReadyToVoteProps {
  items: GetReadyToVoteItem[];
}

const GetReadyToVote: FC<GetReadyToVoteProps> = ({ items }) => {
  const [modalItem, setModalItem] = useState<GetReadyToVoteItem | null>(null);

  if (items.length === 0) {
    return null;
  }

  return (
    <section className="get-ready-to-vote">
      <h2 className="election-hub-2026-hdg-block">Get ready to vote</h2>
      <div className="get-ready-to-vote-boxes">
        {items.map((box) => (
          <div className="get-ready-to-vote-box" key={box.linkUrl}>
            {box.imageUrl ? (
              <img
                src={box.imageUrl}
                alt={box.title}
                className="get-ready-to-vote-box-img"
                loading="lazy"
              />
            ) : (
              <div className="get-ready-to-vote-box-img get-ready-to-vote-box-img-placeholder" />
            )}
            <div className="get-ready-to-vote-box-body">
              <h3 className="get-ready-to-vote-box-title">{box.title}</h3>
              <p className="get-ready-to-vote-box-desc">{box.description}</p>
              {box.isModal ? (
                <button
                  type="button"
                  className="btn btn-primary btn-slim no-text-transform get-ready-to-vote-box-btn"
                  onClick={() => setModalItem(box)}
                >
                  {box.buttonText}
                </button>
              ) : (
                <AppSafeLink
                  href={box.linkUrl}
                  className="btn btn-primary btn-slim no-text-transform get-ready-to-vote-box-btn"
                >
                  {box.buttonText}
                </AppSafeLink>
              )}
            </div>
          </div>
        ))}
      </div>
      <Modal
        show={modalItem !== null}
        onClose={() => setModalItem(null)}
        blurBackground
      >
        <div className="get-ready-to-vote-modal">
          <Header
            className="get-ready-to-vote-modal-header"
            title={modalItem?.buttonText ?? ''}
            onClose={() => setModalItem(null)}
            closeIcon={<IconClose color="var(--color-mpr-charcoal)" />}
          />
          {modalItem && (
            <iframe
              src={modalItem.linkUrl}
              title={modalItem.title}
              style={{ border: '0px #FFFFFF none', maxWidth: '100%' }}
              scrolling="auto"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
              height="650"
              width="450"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </Modal>
    </section>
  );
};

export default GetReadyToVote;
